<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <Table 
            ref="orderTableRef"
            :table="table"
            @expandRow="expandRow"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @selectRow="selectRow"
            @selectAllRow="selectAllRow"
            @sorterChange="sorterChange"
            @cellClick="cellClick"
        >
            <!-- 表头操作 -->
            <!-- <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.order.createOrder'" @click="handle('createOrder')">
                    <icon-plus-circle size="13" style="marginRight:5px;"/>
                    {{ $t('order.create') }}
                </a-button>
            </template> -->

            <!-- 父表格操作 -->
            <template v-slot:tableOperate="{ props }">
                <a-button 
                    type="primary" size="mini" 
                    style="margin: 1px;width: 130px;"
                    :disabled="props.record.credit_validate_val == 1 || props.record.business_order_status_val == 3"
                    @click="handle('edit',props.record)"
                >{{ $t('dealerPreOrder.verifyConfirm') }}</a-button>
                <a-button 
                    type="primary" status="warning" size="mini" 
                    style="margin: 1px;width: 130px;"
                    :disabled="props.record.credit_validate_val != 1 || props.record.business_order_status_val == 3"
                    @click="handle('close',props.record)"
                >{{ $t('dealerPreOrder.close') }}</a-button>
            </template>

            <!-- 父表格自定义字段 -->
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'order_name'" :class="{'orderName': props.record.order_name != '-'}" @click="goOrderList(props.record.order_name)">{{ props.record.order_name }}</div>
                <div v-if="props.column.key == 'business_order_status'">
                    <a-tag :color="props.record.business_order_status_val == 1? 'blue' : props.record.business_order_status_val == 3? 'green' : 'gray'">{{ props.record.business_order_status }}</a-tag>
                </div>
                <div v-if="props.column.key == 'credit_validate'">
                    <a-tag v-if="props.record.credit_validate_val != undefined" :color="props.record.credit_validate_val == 1? 'red' : 'green'">{{ props.record.credit_validate }}</a-tag>
                    <span v-else>-</span>
                </div>
                <div v-if="props.column.key == 'customer_level'">
                    <a-tag v-if="props.record.customer_level_val !== undefined" :color="props.record.customer_level_val == 1? 'green' : props.record.customer_level_val == 3? 'gray' : props.record.customer_level_val == 5? 'gold' : 'blue'">{{ props.record.customer_level }}</a-tag>
                    <span v-else>-</span>
                </div>
                <!-- <div v-if="props.column.key == 'amount'">
                    <div class="amountBlock" :class="{'amountBlock2':locale == 'zh'}">   
                    <p>
                       <span> {{ $t('order.orderAmount') }}：</span>
                       {{ props.record.order_amount }}
                    </p>
                    <p>
                        <span> {{ $t('order.payAmount') }}：</span>
                        {{ props.record.pay_amount }}
                    </p>
                    <div v-if="props.record.showAmount">
                        <p>
                            <span>{{ $t('order.orderDiscount') }}：</span>
                            {{ props.record.order_discount }}
                        </p>
                        <p>
                            <span>{{ $t('order.cargoFreight') }}：</span>
                            {{ props.record.cargo_freight }}
                        </p>
                        <p>
                            <span>{{ $t('order.orderTax') }}：</span>
                            {{ props.record.order_tax }}
                        </p>
                        <p>
                            <span>{{ $t('order.taxRate') }}：</span>
                            {{ props.record.tax_rate }}
                        </p>    
                    </div>
                    <div class="arrowTop" :class="{'arrowBottom': props.record.showAmount}">
                        <p style="color: #4393fa;cursor: pointer;" v-if="!props.record.showAmount" @click="props.record.showAmount = !props.record.showAmount">
                            <icon-down-circle size="14"/>
                        </p>
                        <p style="color: #4393fa;cursor: pointer;" v-else @click="props.record.showAmount = !props.record.showAmount">
                            <icon-up-circle size="14" />
                        </p>
                    </div>
                </div>
                </div> -->
            </template>

            <!-- 子表格自定义子字段 -->
            <template v-slot:childColumns="{ props }">
                <div v-if="props.column.key == 'delivery_type'">
                    <a-tag checkable :color="props.record.delivery_type_val == '1'? 'blue' : props.record.delivery_type_val == '2'? 'green' : 'gold'">{{ props.record.delivery_type }}</a-tag>
                </div>
            </template>

            <!-- <template v-slot:childTableOperate="{ props }">
                <a-button 
                    v-permission="'setting.order.viewVersion'" 
                    type="text" size="mini" 
                    style="padding: 0 5px;"
                    @click="handle('viewVersion',props.record)"
                >{{ $t('order.viewVersion2') }}</a-button>
            </template> -->
        </Table>

    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { DealerApi } from '@/api/DealerApi.js';
    import { OrderApi } from '@/api/OrderApi.js'; 
    import { FinancialApi } from '@/api/FinancialApi.js'; 
    import { Message, Modal } from '@arco-design/web-vue';
    import { useRouter } from 'vue-router';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { 
        PreOrderListQuery,
        // CreateOrderForm1, 
        // CreateOrderForm2,
        // CreateOrderForm3,
    } from './queryConfig/PreOrderListQuery.js';
    
    import { dateToTimestamp, timestampToDate, formatterToPoint, formatterToComma, getNowDate, getWeek } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { multiply, add, subtract, divide } from 'accurate-core';

    const router = useRouter()
    const localeStore = useLocale()
    const { t } = useI18n()

    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    const locale = ref(localStorage.getItem('locale'))

    const orderSource = ref({})
    const orderTableRef  = ref(null)
    const showForm = ref(false)
    const queryForm = reactive(PreOrderListQuery)

    // 父表格
    const table = ref({
        datas:[],
        columns:[
            {
                // title: '预订单名称',
                title:t('dealerPreOrder.businessOrderName'),
                dataIndex: 'business_order_name',
                key:'business_order_name',
                width:'140',
                align:'left',
                fixed:'left',
            },
            {
                // title: '订单名称',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'140',
                align:'left',
                slotName:'slot',
            },
            {
                // title: '订单来源',
                title:t('order.orderSource'),
                dataIndex: 'source',
                key:'source',
                width:'150',
                align:'left',
            },
            {
                // title: '订单状态',
                title:t('order.orderStatus'),
                dataIndex: 'business_order_status',
                key:'business_order_status',
                width:'120',
                align:'left',
                slotName: 'slot'
            }, 
            {
                // title: '信用额度验证',
                title:t('dealerPreOrder.creditValidate'),
                dataIndex: 'credit_validate',
                key:'credit_validate',
                width:'140',
                align:'left',
                slotName: 'slot'
            },
            {
                // title: '数量',
                title:t('order.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'110',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '金额',
                title:t('order.orderAmount'),
                dataIndex: 'order_amount',
                key:'order_amount',
                width:'140',
                slotName:'order_amount',
                align:'left',
                // slotName:'slot',
            },
            {
                // title: '备注',
                title:t('dealerPreOrder.userNote'),
                dataIndex: 'user_note',
                key:'user_note',
                width:'180',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '订单时间',
                title:t('order.orderTimestamp'),
                dataIndex: 'order_timestamp',
                key:'order_timestamp',
                width:'140',
                align:'left',
                ellipsis:true,
                tooltip:true,
                sortable: {
                    sortDirections: ['ascend', 'descend'],
                },
            },
            // {
            //     // title: 'Dealer客户编码',
            //     title:t('order.customerErpCode'),
            //     dataIndex: 'customer_erp_code',
            //     key:'customer_erp_code',
            //     width:'170',
            //     align:'left',
            // },  
            // {
            //     // title: '客户邮箱',
            //     title:t('order.customerEmail'),
            //     dataIndex: 'customer_email',
            //     key:'customer_email',
            //     width:'220',
            //     align:'left',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            // {
            //     // title: '客户名称',
            //     title:t('order.customerName'),
            //     dataIndex: 'customer_name',
            //     key:'customer_name',
            //     width:'200',
            //     // slotName:'slot',
            //     align:'left',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            // {
            //     // title: '客户等级',
            //     title:t('dealerPreOrder.customerLevel'),
            //     dataIndex: 'customer_level',
            //     key:'customer_level',
            //     width:'200',
            //     slotName:'slot',
            //     align:'left',
            //     // ellipsis:true,
            //     // tooltip:true,
            // },
            {
                // title: '国家',
                title:t('order.country'),
                dataIndex: 'country',
                key:'country',
                width:'150',
                align:'left',
            },
            // {
            //     // title: '下单日期',
            //     title:t('order.createDate'),
            //     dataIndex: 'create_date',
            //     key:'create_date',
            //     width:'190',
            //     align:'left',
            // },
            // {
            //     title: t('base.operate'),
            //     dataIndex: 'Optional',
            //     key:'Optional',
            //     slotName:'optional',
            //     width: '180',
            //     align:'center',
            //     fixed:'right'
            // }
        ],
        configs:{
            scroll:{
                // x:1000,
                y: 580
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    // 子表格
    const innerColumns = ref([ 
        {
            // title: 'No.',
            title:'#',
            dataIndex: 'serial',
            key: 'product_name',
            width: '80',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: 'sku',
            title:t('order.sku'),
            dataIndex: 'sku',
            key: 'sku',
            width: '220',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '物料编码',
            title:t('order.inventoryCode'),
            dataIndex: 'inventory_code',
            key: 'inventory_code',
            width: '180',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        // {
        //     // title: '产品类别',
        //     title:t('dealerPreOrder.categoryType'),
        //     dataIndex: 'product_code',
        //     key: 'product_code',
        //     width: '160',
        //     align: 'left',
        // },
        {
            // title: '上市年份',
            title:t('dealerPreOrder.modelYear'),
            dataIndex: 'model_year',
            key: 'model_year',
            width: '100',
            align: 'left',
        },
        {
            // title: '车型',
            title:t('dealerPreOrder.modelVersion'),
            dataIndex: 'model_version',
            key: 'model_version',
            width: '220',
            align: 'left',
        },
        {
            // title: '颜色',
            title:t('dealerPreOrder.frameColor'),
            dataIndex: 'frame_color',
            key: 'frame_color',
            width: '120',
            align: 'left',
        },
        {
            // title: '车架',
            title:t('dealerPreOrder.frameShape'),
            dataIndex: 'frame_shape',
            key: 'frame_shape',
            width: '120',
            align: 'left',
        },
        {
            // title: '尺寸',
            title:t('dealerPreOrder.frameSize'),
            dataIndex: 'frame_size',
            key: 'frame_size',
            width: '120',
            align: 'left',
        },
        {
            // title: '单价',
            title:t('dealerPreOrder.price'),
            dataIndex: 'amount',
            key: 'amount',
            width: '130',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '数量',
            title:t('order.quantity'),
            dataIndex: 'quantity',
            key: 'quantity',
            width: '120',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '总价',
            title:t('order.payAmount'),
            dataIndex: 'pay_amount',
            key: 'pay_amount',
            width: '120',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '订单税额',
            title:t('order.orderTax'),
            dataIndex: 'order_tax',
            key: 'order_tax',
            width: '120',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '税率',
            title:t('order.taxRate'),
            dataIndex: 'tax_rate',
            key: 'tax_rate',
            width: '120',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '发货方式',
            title:t('order.deliveryType'),
            dataIndex: 'delivery_type',
            key: 'delivery_type',
            width: '120',
            align: 'left',
            ellipsis:true,
            tooltip:true,
            slotName:'slot',
        },  
        {
            // title: '预计发货时间',
            title:t('order.handleTimestamp'),
            dataIndex: 'handle_timestamp_val',
            key: 'handle_timestamp_val',
            width: '130',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        // {
        //     // title: '操作',
        //     title:t('order.operate'),
        //     dataIndex: 'Optional',
        //     key: 'Optional',
        //     slotName: 'optional',
        //     width: '260',
        //     align: 'center',
        //     fixed: 'right'
        // }   
    ])

    const innerConfigs = ref({
        scroll: {
            x: 1000,
            y: 200,
        },
        stripe: false,
        bordered: false,
        size: 'large',
        loading: false,
        // rowSelection:{
        //     type: 'checkbox',
        //     showCheckedAll: true,
        //     onlyCurrent: false,
        // },
        selected:[],
        pagination: false,
    })


    const handle = (type, row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                // queryForm.formData.begin_date = !queryForm.formData.order_date? '' : dateToTimestamp(`${queryForm.formData.order_date[0]} 00:00:00`)
                // queryForm.formData.end_date = !queryForm.formData.order_date? '' : dateToTimestamp(`${queryForm.formData.order_date[1]} 23:59:59`) 
                getDealerOrderHead()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                // queryForm.formData.customer_name = ''
                // queryForm.formData.begin_date = ''
                // queryForm.formData.end_date = ''
                table.value.configs.pagination.current = 1
                getDealerOrderHead()
                break;
            case 'edit':
                router.push({name:'OrderOrderList',state:{fromPage:'DealerBusinessOrder', row: JSON.stringify(row)}})
                break;
            case 'close':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content:t('dealerPreOrder.closeOrderTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        closeOrder(row)
                    },
                })
                break;
            
        }
    }


    // 展开搜索栏
    const showFormPanel = (val)=>{
        showForm.value = val
    }

    // 列表查询-select
    const handleSelectChange = ( val, opt, key )=>{
        console.log(val,opt,key,'val,opt,key')
        if(key == 'customer_id'){
            if(!val){
                queryForm.formData.customer_name = ''
            }else{
                let item = queryForm.formField.find(i=> i.key == 'customer_id')
                let opt = item.options.find(i=> i.value == val)
                queryForm.formData.customer_name = opt.label
            }
        }else{
            queryForm.formData[key] = val
        }
        table.value.configs.pagination.current = 1
        getDealerOrderHead()
    }

    // 列表查询-input
    const handleInputClear = (val,item)=>{
        table.value.configs.pagination.current = 1
        getDealerOrderHead()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getDealerOrderHead()
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getDealerOrderHead()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getDealerOrderHead()
    }

    // 展开行
    const expandRow = (rowKey,record)=>{
        orderTableRef.value.expandedKeys = orderTableRef.value.expandedKeys.length !== 0? [record.id] : []
        orderTableRef.value.selectedKeys = []
        // orderRowData.value = record
        // table.value.datas.forEach(item=>{
        //     if(item.selected) item.selected = []
        // })
        getDealerOrderLine(record)
    }

    // 获取经销商业务订单列表-头
    const getDealerOrderHead = async()=>{
        let param = {
            ...queryForm.formData,
            business_order_name: queryForm.formData.business_order_name.trim(),
            order_name:queryForm.formData.order_name.trim(),
        }

        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await DealerApi.getInstance().getDealerOrderHead(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.forEach((item,index)=>{
                item.source_val = item.source
                item.business_order_name = item.business_order_name == undefined? '-' : item.business_order_name
                item.order_name = item.order_name == undefined? '-' : item.order_name
                item.source = item.source == undefined? '-' : orderSource.value[item.source]
                item.business_order_status_val = item.business_order_status
                item.business_order_status = item.business_order_status == undefined? '-' : item.business_order_status == 1? t('dealerPreOrder.ordered') : item.business_order_status == 3? t('dealerPreOrder.confirm') : t('dealerPreOrder.cancel')
                item.courier_status = item.courier_status == undefined? '-' : item.courier_status
                item.quantity = item.quantity == undefined? '-' : item.quantity
                item.credit_validate_val = item.credit_validate
                item.credit_validate = item.credit_validate == undefined? '-' : item.credit_validate == 1? t('dealerPreOrder.validateFail') : t('dealerPreOrder.validateSuccess')

                item.order_amount = item.order_amount == undefined? '-' : `€ ${Number(item.order_amount).toFixed(2)}`
                item.pay_amount = item.pay_amount == undefined? '-' : `€ ${Number(item.pay_amount).toFixed(2)}`
                item.order_discount = item.order_discount == undefined? '-' : `€ ${Number(item.order_discount).toFixed(2)}`
                item.cargo_freight = item.cargo_freight == undefined? '-' : `€ ${Number(item.cargo_freight).toFixed(2)}`
                item.order_tax = item.order_tax == undefined? '-' : `€ ${Number(item.order_tax).toFixed(2)}`
                item.tax_rate = item.tax_rate == undefined? '-' : item.tax_rate
                item.create_date = item.create_date == undefined? '-' : item.create_date.split(' ')[0]

                item.order_timestamp = item.order_timestamp == undefined? '-' : timestampToDate(item.order_timestamp * 1000).split(' ')[0]
                item.customer_erp_code = item.customer_erp_code == undefined? '-' : item.customer_erp_code
                item.customer_email = item.customer_email == undefined? '-' : item.customer_email
                item.customer_name = item.customer_name == undefined? '-' : item.customer_name
                item.customer_level_val = item.customer_level
                item.customer_level = item.customer_level == undefined? '-' : item.customer_level == 1? t('dealerPreOrder.bronze') : item.customer_level == 3? t('dealerPreOrder.silver') : item.customer_level == 5? t('dealerPreOrder.gold') : t('dealerPreOrder.platinum')
                item.country = item.country == undefined? '-' : item.country
                item.child = {
                    innerDatas:[],
                    innerColumns:innerColumns.value,
                    innerConfigs:innerConfigs.value,
                }

            })

            table.value.datas = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取经销商业务订单列表-行
    const getDealerOrderLine = async(row)=>{
        let param = {
            business_order_id: row.id
        }
        let item = table.value.datas.find(i=> i.id == row.id)
        item.child.innerConfigs.loading = true

        let res = await DealerApi.getInstance().getDealerOrderLine(param)
        if(res.code == 0){
            res.data.forEach((item,index)=>{
                item.serial = index + 1
                item.sku = item.sku == undefined? '-' : item.sku
                item.inventory_code = item.inventory_code == undefined? '-' : item.inventory_code
                // item.product_code = item.product_code == undefined? '-' : item.product_code
                item.model_year = item.product_map.model_year == undefined? '-' : item.product_map.model_year == 'MY23'? '2023' : '2024'
                item.model_version = item.product_map.model == undefined? '-' : `${item.product_map.model}, ${item.product_map.hf_version}`
                item.frame_color = item.product_map.frame_color == undefined? '-' : item.product_map.frame_color
                item.frame_shape = item.product_map.frame_shape == undefined? '-' : item.product_map.frame_shape
                item.frame_size = item.product_map.frame_size == undefined? '-' : item.product_map.frame_size
                item.amount = item.amount == undefined? '-' : `€ ${Number(item.amount).toFixed(2)}`
                item.quantity = item.quantity == undefined? '-' : item.quantity
                item.pay_amount = item.pay_amount == undefined? '-' : `€ ${Number(item.pay_amount).toFixed(2)}`
                item.order_tax = item.order_tax == undefined? '-' : `€ ${Number(item.order_tax).toFixed(2)}`
                item.tax_rate = item.tax_rate == undefined? '-' : item.tax_rate
                item.delivery_type_val = item.delivery_type
                item.delivery_type = item.delivery_type == undefined? '-' : item.delivery_type == '1'? t('dealerPreOrder.standard') : item.delivery_type == '2'? t('dealerPreOrder.express') : t('dealerPreOrder.collection')
                item.handle_timestamp_val = item.handle_timestamp_val == undefined? '-' : timestampToDate(item.handle_timestamp_val)
            })

            item.child.innerDatas = res.data
            item.child.innerConfigs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 关闭业务订单
    const closeOrder = async (row)=>{
        let res = await DealerApi.getInstance().closeOrder(row.id)
        if(res.code == 0){
            Message.success(t('dealerPreOrder.closeSuccess'))
            table.value.configs.pagination.current = 1
            getDealerOrderHead()
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单来源类型 和 erp客户编码
    const getOrderSource = async ()=>{
        let res = await OrderApi.getInstance().getOrderSource({enable_flag:1})
        if(res.code == 0){
            let queryFormItem = queryForm.formField.find(i=> i.key == 'source')
            // let item = createOrderForm1.formField.find(i=> i.key == 'source')
            // let customerItem = addCustomerForm.formField.find(i=> i.key == 'source')
            // queryFormItem.options = []
            // item.options = []
            // customerItem.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                // if(i.id && i.id != '1'){
                //     customerItem.options.push({
                //         label:i.customer_name,
                //         value:i.id, // 来源类型 
                //         code: i.customer_number, // erp客户编码
                //     })
                // }

                // item.options.push({
                //     label:i.id == 1? `Shopify | ${i.customer_number}` : `${i.customer_name} | ${i.customer_number}`,
                //     value:i.id, // 来源类型 
                //     code: i.customer_number, // erp客户编码
                //     disabled: i.id == 1,
                //     type: i.type
                // })

                if(i.id){
                    orderSource.value[i.id] = i.id == 1? 'Shopify' : i.customer_name
                }

                // console.log(orderSource.value,'orderSource.value')
            })
            // console.log(orderSource.value,'mmmmmm12')
            res.data.length > 0 && res.data.forEach(i=>{
                queryFormItem.options.push({
                    label: i.id == '1'? 'Shopify' : i.customer_name,
                    value:i.id, // 来源类型
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取国家下拉配置
    const getCountry = async ()=>{
        let res = await OrderApi.getInstance().getCountry({enable_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'country')
            // let createItem = createOrderForm3.formField.find(i=> i.key == 'country')
            // let customerItem = addCustomerForm.formField.find(i=> i.key == 'country')
            item.options = []
            // createItem.options = []
            // customerItem.options = []
            res.data.forEach(i=>{
                item.options.push({
                    label:i.country,
                    value:i.country
                })
                // createItem.options.push({
                //     label:i.country,
                //     value:i.country
                // })
                // customerItem.options.push({
                //     label:i.country,
                //     value:i.country,
                //     code:i.country_code, // 国家编码
                // })
            })
        }else{
            Message.error(res.msg)
        }
    } 

    // 跳转到订单管理
    const goOrderList = (order_name)=>{
        if(order_name == '-') return
        else router.push({path:'/OrderList/OrderList', query:{order_name:order_name,fromPage:'DealerBusinessOrder2'}})
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 80
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(async ()=>{
        await getOrderSource()
        getDealerOrderHead()
        getCountry()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })

        sessionStorage.removeItem('toPage')
       
    })


</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }


    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-picker-size-medium{
    height: 28px;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 0px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-table-cell-fixed-expand{
    margin-bottom:15px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/.childrenTable{
    .arco-table-th{
        background-color: #333 !important;
        color: #fff;
        border-bottom: 1px solid #eee;
        padding: 0;
        font-weight: 300;
        font-size:12px;
    }
    .arco-table-td{
        padding: 0;
        background-color: #ddd !important;
    }

    .arco-icon-filter{
        color: #fff;
    }
}

.amountBlock{
    position: relative;
    font-size:13px;
    color:#666;
    p{
        margin:0px;

        span{
            display: inline-block;
            width: 120px;
        }
    }
}

.amountBlock2{
    position: relative;
    font-size:13px;
    color:#666;
    p{
        margin:0px;

        span{
            display: inline-block;
            width: 70px;
        }
    }
}

.orderName{
    color: #4080ff;
    cursor: pointer;
}

</style>